import {TimelineLite} from "gsap";

export interface SimplePresentation {
    start(controller: SimplePresentationRunnerController): void;

    shouldRun(): boolean;
}

export interface SimplePresentationRunnerController {
    finish: () => void,
    setSkipCallback: (skipCallback?: Function) => void
}

export class SimplePresentationRunner {
    public static run(presentations: SimplePresentation[], finishCallback: Function, setSkipCallback: (skipCallback?: Function) => void) {
        const localPresentations = presentations.concat();
        const presentation: SimplePresentation | undefined = localPresentations.shift();
        if (presentation == undefined) {
            finishCallback();
        } else {
            if (presentation.shouldRun()) {
                presentation.start({
                    finish: () => SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback),
                    setSkipCallback: setSkipCallback
                });
            } else {
                SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback)
            }
        }
    }

    public static skip(tl: TimelineLite): void {
        tl.progress(1);
        tl.kill();
    }
}